import { EntityType } from "@repo/types/enums";
import type { TicketDTO } from "../types/dtos";
import type { RecordId } from "@repo/types/ui/tables";
import { useTicketColumns } from "../hooks/columns";
import { PageView } from "../components/common/PageView";
import ViewTicket from "../components/tickets/ViewTicket";
import NewTicket from "./NewTicket";

const Tickets = () => (
  <PageView<TicketDTO>
    entityType={EntityType.Ticket}
    useColumns={useTicketColumns}
    onCellValueUpdated={() => {
      // Implement the logic to update the cell value for a ticket record
    }}
    renderRecord={(selectedTicketGuid: RecordId) => (
      <ViewTicket ticketId={selectedTicketGuid} />
    )}
    renderNewRecord={() => <NewTicket />}
  />
);

export { Tickets };
